export enum UploadResourceTypeEnum {
  RESOURCES = 'Digital Resources',
  ASSESSMENTS = 'Paper Assessments Responses',
}
